import GEA from '../gea/gea.js';
import DebugHelper from '../helpers/debug-helper';

class PianoSettings {
	constructor() {
		this.logger = new DebugHelper('Piano Settings');
	}

	init() {
		this.setupWindowTp();
		this.addCustomVariables();
	}

	setupWindowTp() {
		window.tp = [];
	}

	addCustomVariables() {
		if (typeof window.bi_piano !== 'undefined') {
			window.tp.push(['setCustomVariable', 'postID', window.bi_piano.post_id]);
			window.tp.push([
				'setCustomVariable',
				'pubDate',
				window.bi_piano.pub_date,
			]);
			window.tp.push(['setCustomVariable', 'premiumState', this.isPremium()]);
			window.tp.push([
				'setCustomVariable',
				'premiumType',
				window.bi_piano.premium_type,
			]);
			window.tp.push([
				'setCustomVariable',
				'primaryCategory',
				window.bi_piano.primary_category,
			]);
			window.tp.push([
				'setCustomVariable',
				'isGruenderszene',
				window.bi_piano.is_gruenderszene,
			]);
			window.tp.push([
				'setCustomVariable',
				'isShared',
				window.bi_piano.is_shared,
			]);
			window.tp.push([
				'setCustomVariable',
				'isRegistrationOnly',
				window.bi_piano.is_registration_only,
			]);
			window.tp.push(['setContentCreated', window.bi_piano.pub_date]);
			this.sendTaxonomyCustomVariables();
			this.sendAuthor();
			this.sendTags();
			this.sendContentSection();
			this.sendPaywallExpiration();
			this.sendAppData();
			this.sendGeaData();
		}
	}

	sendTaxonomyCustomVariables() {
		if (typeof window.bi_piano.taxonomies !== 'undefined') {
			const taxonomies = Object.values(window.bi_piano.taxonomies);

			for (const taxonomy in taxonomies) {
				for (const term_key in taxonomies[taxonomy]) {
					window.tp.push([
						'setCustomVariable',
						taxonomies[taxonomy][term_key],
						'1',
					]);
				}
			}
		}
	}

	sendAuthor() {
		if (typeof window.bi_piano.author !== 'undefined') {
			window.tp.push(['setContentAuthor', window.bi_piano.author]);
		}
	}

	sendTags() {
		if (typeof window.bi_piano.taxonomies !== 'undefined') {
			const allTags = [];

			if (
				typeof window.bi_piano.is_premium !== 'undefined' &&
				window.bi_piano.is_premium
			) {
				allTags.push('is_premium');
			}

			if (typeof window.bi_piano.taxonomies.tags !== 'undefined') {
				allTags.push(window.bi_piano.taxonomies.tags);
			}

			if (typeof window.bi_piano.taxonomies.special_tags !== 'undefined') {
				allTags.push(window.bi_piano.taxonomies.special_tags);
			}

			window.tp.push(['setTags', allTags.flat()]);
		}
	}

	sendContentSection() {
		if (typeof window.bi_piano.primary_category !== 'undefined') {
			window.tp.push(['setContentSection', window.bi_piano.primary_category]);
		}
	}

	sendPaywallExpiration() {
		if (
			typeof bi_piano.has_expiring_paywall !== 'undefined' &&
			typeof bi_piano.paywall_expiration_days !== 'undefined'
		) {
			window.tp.push([
				'setCustomVariable',
				'hasExpiringPaywall',
				bi_piano.has_expiring_paywall,
			]);
			window.tp.push([
				'setCustomVariable',
				'paywallExpirationDays',
				bi_piano.paywall_expiration_days,
			]);
		}
	}

	isPremium() {
		if (
			typeof window.bi_piano.is_premium === 'string' &&
			window.bi_piano.is_premium &&
			window.bi_piano.post_id
		) {
			return '1';
		}

		if (
			typeof window.bi_piano.is_premium === 'string' &&
			!window.bi_piano.is_premium &&
			window.bi_piano.post_id
		) {
			return '0';
		}

		return 'undefined';
	}

	sendAppData() {
		if (typeof bi_piano.is_app !== 'undefined') {
			window.tp.push(['setCustomVariable', 'isApp', bi_piano.is_app]);
			window.tp.push(['setCustomVariable', 'appType', bi_piano.app_type]);
		} else {
			window.tp.push(['setCustomVariable', 'isApp', '0']);
		}
	}

	sendGeaData() {
		this.logger.log(
			'Set Piano isGeaRequest custom variable: ',
			GEA.isValidUrl(window.location.href),
		);
		window.tp.push([
			'setCustomVariable',
			'isGeaRequest',
			GEA.isValidUrl(window.location.href),
		]);
	}
}

const instance = new PianoSettings();
export default instance;
